//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum AggregationStatType {
  Comments = 'comments',
  EngagementRate = 'engagementrate',
  EngagementRateWithReach = 'engagementratewithreach',
  Followers = 'followers',
  Impressions = 'impressions',
  Likes = 'likes',
  Reach = 'reach',
  Repins = 'repins',
  StoryCompletionRate = 'completion',
  TotalEngagement = 'totalengagement',
  ViewEngagementRate = 'viewengagementrate',
  Views = 'views',
}

type PostStatAggregationType =
  | AggregationStatType.Comments
  | AggregationStatType.EngagementRate
  | AggregationStatType.EngagementRateWithReach
  | AggregationStatType.Followers
  | AggregationStatType.Impressions
  | AggregationStatType.Likes
  | AggregationStatType.Reach
  | AggregationStatType.TotalEngagement
  | AggregationStatType.ViewEngagementRate
  | AggregationStatType.Views;

export type PostsStatAggregationArray =
  IAggregationStat<PostStatAggregationType>[];

export type PostStatHistogramAggregationType =
  | AggregationStatType.Comments
  | AggregationStatType.EngagementRate
  | AggregationStatType.EngagementRateWithReach
  | AggregationStatType.Followers
  | AggregationStatType.Impressions
  | AggregationStatType.Likes
  | AggregationStatType.Reach
  | AggregationStatType.TotalEngagement
  | AggregationStatType.ViewEngagementRate;

export type PostsStatHistogramArray =
  IAggregationResultHistogramBucket<PostStatHistogramAggregationType>[];

export interface IAggregationStat<T extends AggregationStatType> {
  name: T;
  value: IAggregationStatValue;
}

export interface IAggregationStatValue {
  [AggregationStatValueType.Avg]: number;
  [AggregationStatValueType.Max]: number;
  [AggregationStatValueType.Min]: number;
  [AggregationStatValueType.Sum]: number;
  [AggregationStatValueType.Total]?: number;
}

export enum AggregationStatValueType {
  Avg = 'avg',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  Total = 'total',
}

export interface IAggregationResultHistogramBucket<
  T extends AggregationStatType,
> {
  date: Date;
  count: number;
  stats: IAggregationStat<T>[];
}
